<template>
    <div :class="['col',...this.clazz]">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        name: "vCol",
        props:{
            clazz:{
                default:function () {
                    return []
                },
                type:Array
            }
        }
    }
</script>

<style scoped>

</style>